export default __webpack_public_path__ + "static/media/computer-icons-user-profile-avatar.32e79001.jpg";